module.exports = __webpack_public_path__ + "img/key.2f0d93c2.svg";